import React from 'react';

import Check from '@/components/commons/icons/Check';

interface Props {
    readonly currentStep: number;
    readonly totalSteps: number;
    readonly stepNames: object;
}

function OnboardingStepVisual({ totalSteps, currentStep, stepNames }: Props) {
    const buildStep = (complete, current, last, index) => {
        const completeClasses = 'bg-progressBarBlue border-progressBarBlue';
        const currentClasses = 'bg-cirrusWhite border-black border-cirrusWhite';
        const incompleteClasses = 'border-cirrusWhite';
        let styles = '';
        if (current) {
            styles = currentClasses;
        } else if (complete) {
            styles = completeClasses;
        } else {
            styles = incompleteClasses;
        }
        return (
            <div key={`step-${index}`} className="pt-4 sm:pt-0 flex flex-row items-center justify-centeer">
                <span className={`shrink-0 inline-flex items-center justify-center rounded-full w-8 h-8 border ${styles}`}>
                    {complete
                        ? <Check className="m-1 h-6 w-6 text-white" />
                        : <span className={`font-instrument font-medium text-sm ${current ? 'text-noonBlue' : 'text-cirrusWhite'}`}>{index + 1}</span>}
                </span>
                <span className={`pr-2 pl-2 text-cirrusWhite text-sm ${!last && 'sm:pr-6'}`}>
                    <span className="hidden md:block">{stepNames ? stepNames[index] : ''}</span>
                </span>
            </div>
        );
    };

    const buildVisual = () => {
        const components = [];
        for (let i = 0; i <= totalSteps; i++) {
            components.push(buildStep(i < currentStep, i === currentStep, i === totalSteps, i));
        }
        return components;
    };

    return (
        <div className="flex flex-row items-center">
            {buildVisual()}
        </div>
    );
}

export default OnboardingStepVisual;
